/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Bridge_Access_Space_GrantInputs */



/**
* | output |
* | --- |
* | "Connector-bound · the connection's own credential · its admins, and members granted invoke_api on it · no stored credential" |
*
* @param {Api_Bridge_Access_Space_GrantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_bridge_access_space_grant = /** @type {((inputs?: Api_Bridge_Access_Space_GrantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Bridge_Access_Space_GrantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Connector-gebunden · die eigenen Zugangsdaten der Verbindung · ihre Admins und Mitglieder mit Freigabe für invoke_api · keine gespeicherten Zugangsdaten")
	return /** @type {LocalizedString} */ ("Connector-bound · the connection's own credential · its admins, and members granted invoke_api on it · no stored credential")
});